export { default } from "./RegistroUsuarios";
